import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetTenantBillingQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetTenantBillingQuery = { __typename?: 'Query', tenant?: { __typename?: 'TenantStateData', tenantId: string, name: string, billing: { __typename?: 'TenantBillingData', subscriptionId?: string | null, currency: string, frequency: Types.BillingFrequency, status: Types.BillingStatus, activeChargeAmount?: number | null, currentPeriodEnd?: Types.TDateISO | null, cancelAtPeriodEnd: boolean, cancelAt?: Types.TDateISO | null, lastPaymentDate?: Types.TDateISO | null, lastPaymentAmount?: number | null, hasLiveContract: boolean, stripeCustomerLinked: boolean, contractStartDate?: Types.TDateISO | null, contractEndDate?: Types.TDateISO | null, termEndDate?: Types.TDateISO | null, taxReadiness?: { __typename?: 'TenantTaxReadiness', hasBillingAddress: boolean, automaticTaxStatus: Types.TenantAutomaticTaxStatus, taxExempt: Types.TenantTaxExemptStatus, lastFailure?: { __typename?: 'TenantTaxFailure', reason: string } | null } | null, upcomingInvoice?: { __typename?: 'TenantInvoiceSummary', subtotal: number, tax: number, total: number, amountPaid: number, isEstimate: boolean } | null, lastInvoice?: { __typename?: 'TenantInvoiceSummary', subtotal: number, tax: number, total: number, amountPaid: number, isEstimate: boolean } | null, cadenceOffers: Array<{ __typename?: 'TenantCadenceOffer', frequency: Types.BillingFrequency, baseAmount: number, cardEligible: boolean }>, contractBilling?: { __typename?: 'TenantContractBillingSummary', annualAmountCents: number, collectionMethod: Types.ContractCollectionMethod, currency: string, daysUntilDue?: number | null } | null, installFee?: { __typename?: 'TenantInstallFee', amountCents: number, total?: number | null, description: string, status: Types.ContractFeeStatus, dueDate?: Types.TDateISO | null, hostedInvoiceUrl?: string | null, paidAt?: Types.TDateISO | null, amountPaidCents?: number | null } | null } } | null };

export type TenantInvoiceTotalsFragment = { __typename?: 'TenantInvoiceSummary', subtotal: number, tax: number, total: number, amountPaid: number, isEstimate: boolean };

export type TenantBillingSummaryFragment = { __typename?: 'TenantBillingData', subscriptionId?: string | null, currency: string, frequency: Types.BillingFrequency, status: Types.BillingStatus, activeChargeAmount?: number | null, currentPeriodEnd?: Types.TDateISO | null, cancelAtPeriodEnd: boolean, cancelAt?: Types.TDateISO | null, lastPaymentDate?: Types.TDateISO | null, lastPaymentAmount?: number | null, hasLiveContract: boolean, stripeCustomerLinked: boolean, contractStartDate?: Types.TDateISO | null, contractEndDate?: Types.TDateISO | null, termEndDate?: Types.TDateISO | null, taxReadiness?: { __typename?: 'TenantTaxReadiness', hasBillingAddress: boolean, automaticTaxStatus: Types.TenantAutomaticTaxStatus, taxExempt: Types.TenantTaxExemptStatus, lastFailure?: { __typename?: 'TenantTaxFailure', reason: string } | null } | null, upcomingInvoice?: { __typename?: 'TenantInvoiceSummary', subtotal: number, tax: number, total: number, amountPaid: number, isEstimate: boolean } | null, lastInvoice?: { __typename?: 'TenantInvoiceSummary', subtotal: number, tax: number, total: number, amountPaid: number, isEstimate: boolean } | null, cadenceOffers: Array<{ __typename?: 'TenantCadenceOffer', frequency: Types.BillingFrequency, baseAmount: number, cardEligible: boolean }>, contractBilling?: { __typename?: 'TenantContractBillingSummary', annualAmountCents: number, collectionMethod: Types.ContractCollectionMethod, currency: string, daysUntilDue?: number | null } | null, installFee?: { __typename?: 'TenantInstallFee', amountCents: number, total?: number | null, description: string, status: Types.ContractFeeStatus, dueDate?: Types.TDateISO | null, hostedInvoiceUrl?: string | null, paidAt?: Types.TDateISO | null, amountPaidCents?: number | null } | null };

export const TenantInvoiceTotalsFragmentDoc = new TypedDocumentString(`
    fragment TenantInvoiceTotals on TenantInvoiceSummary {
  subtotal
  tax
  total
  amountPaid
  isEstimate
}
    `, {"fragmentName":"TenantInvoiceTotals"});
export const TenantBillingSummaryFragmentDoc = new TypedDocumentString(`
    fragment TenantBillingSummary on TenantBillingData {
  subscriptionId
  currency
  frequency
  status
  activeChargeAmount
  currentPeriodEnd
  cancelAtPeriodEnd
  cancelAt
  lastPaymentDate
  lastPaymentAmount
  hasLiveContract
  stripeCustomerLinked
  taxReadiness {
    hasBillingAddress
    automaticTaxStatus
    taxExempt
    lastFailure {
      reason
    }
  }
  upcomingInvoice {
    ...TenantInvoiceTotals
  }
  lastInvoice {
    ...TenantInvoiceTotals
  }
  cadenceOffers {
    frequency
    baseAmount
    cardEligible
  }
  contractBilling {
    annualAmountCents
    collectionMethod
    currency
    daysUntilDue
  }
  contractStartDate
  contractEndDate
  termEndDate
  installFee {
    amountCents
    total
    description
    status
    dueDate
    hostedInvoiceUrl
    paidAt
    amountPaidCents
  }
}
    fragment TenantInvoiceTotals on TenantInvoiceSummary {
  subtotal
  tax
  total
  amountPaid
  isEstimate
}`, {"fragmentName":"TenantBillingSummary"});
export const GetTenantBillingDocument = new TypedDocumentString(`
    query GetTenantBilling {
  tenant {
    tenantId
    name
    billing {
      ...TenantBillingSummary
    }
  }
}
    fragment TenantInvoiceTotals on TenantInvoiceSummary {
  subtotal
  tax
  total
  amountPaid
  isEstimate
}
fragment TenantBillingSummary on TenantBillingData {
  subscriptionId
  currency
  frequency
  status
  activeChargeAmount
  currentPeriodEnd
  cancelAtPeriodEnd
  cancelAt
  lastPaymentDate
  lastPaymentAmount
  hasLiveContract
  stripeCustomerLinked
  taxReadiness {
    hasBillingAddress
    automaticTaxStatus
    taxExempt
    lastFailure {
      reason
    }
  }
  upcomingInvoice {
    ...TenantInvoiceTotals
  }
  lastInvoice {
    ...TenantInvoiceTotals
  }
  cadenceOffers {
    frequency
    baseAmount
    cardEligible
  }
  contractBilling {
    annualAmountCents
    collectionMethod
    currency
    daysUntilDue
  }
  contractStartDate
  contractEndDate
  termEndDate
  installFee {
    amountCents
    total
    description
    status
    dueDate
    hostedInvoiceUrl
    paidAt
    amountPaidCents
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetTenantBilling: build.query<GetTenantBillingQuery, GetTenantBillingQueryVariables | void>({
      query: (variables) => ({ document: GetTenantBillingDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetTenantBillingQuery, useLazyGetTenantBillingQuery } = injectedRtkApi;
